import {
  WSButton,
  WSForm,
  WSModal,
  WSText,
  WSTextInput
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { useHistory } from "react-router";
import { useRequestPrincipalUser } from "../../query/users/mutations";
import {
  validatorSignInEmail,
  validatorSignInPassword
} from "../../utils/validators";
import { IAuthorizedAccount } from "@wingspanhq/users";

export const SWITCH_ACCOUNT_PASSWORD_MODAL = "SWITCH_ACCOUNT_PASSWORD_MODAL";
export interface PasswordModalProps {
  account: IAuthorizedAccount;
}

export const PasswordModal: React.FC<PasswordModalProps> = ({ account }) => {
  const history = useHistory();
  const [
    requestPrincipalUser,
    requestPrincipalUserMeta
  ] = useRequestPrincipalUser();

  return (
    <WSModal
      name={SWITCH_ACCOUNT_PASSWORD_MODAL}
      size="S"
      title="Switch Account"
    >
      <WSForm
        onSubmit={values => {
          requestPrincipalUser(values, {
            onSuccess: () => {
              history.push("/member/dashboard");
              window.location.reload();
            }
          });
        }}
        defaultValues={{
          email: account.accessibleMember.user.email,
          password: ""
        }}
        validationSchema={Yup.object().shape({
          email: validatorSignInEmail,
          password: validatorSignInPassword
        })}
      >
        <WSForm.Field
          name="email"
          label="Member's email"
          mb="M"
          component={WSTextInput}
          componentProps={{
            type: "email",
            disabled: true
          }}
        />
        <WSForm.Field
          name="password"
          label="Your password"
          mb="M"
          component={WSTextInput}
          componentProps={{
            type: "password"
          }}
        />
        <WSButton.Primary
          fullWidth
          loading={requestPrincipalUserMeta.isLoading}
        >
          Sign in
        </WSButton.Primary>
        {requestPrincipalUserMeta.error && (
          <WSText.Paragraph mt="L" color="red400">
            {requestPrincipalUserMeta.error?.response?.data.error}
          </WSText.Paragraph>
        )}
      </WSForm>
    </WSModal>
  );
};
